<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form class="fn-clear" :inline="true">
          <!-- <el-form-item label="渠道" class="fn-left">
            <Select key="5" :selected.sync="listQuery.channel_id" :data="channelLists" clearable placeholder="请选择" />
          </el-form-item> -->
          <el-form-item label="学员姓名" class="fn-left">
            <el-input v-model="listQuery.sub_name" placeholder="请输入学员姓名" />
          </el-form-item>
          <!-- <el-form-item label="" class="fn-left">
            <el-checkbox v-model="listQuery.tll_status" true-label="20062018214508001072" false-label="">只看已无效的例子</el-checkbox>
          </el-form-item> -->
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnGetPointManageList()">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">

      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="学员ID" prop="sub_id" align="center" />
        <el-table-column label="店铺" prop="shop_name" align="center" />
        <el-table-column label="学员姓名" prop="sub_name" align="center" />
        <el-table-column label="积分" prop="integral_value" align="center" />

        <el-table-column label="操作" align="center" width="260">
          <template slot-scope="{row}">
            <el-button size="small" type="success" @click="fnFollow(row)">积分流水</el-button>
            <el-button size="small" type="danger" @click="fnUpdate(row)">调整积分</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="增减积分"
      :visible.sync="dialogVisible1"
    >
      <el-form ref="form1" :model="setPostForm" label-width="100px" :rules="rules">
        <el-form-item label="说明" prop="content">
          <el-input v-model="setPostForm.content" type="textarea" />
        </el-form-item>
        <el-form-item label="积分" prop="occur_score">
          <el-input-number v-model="setPostForm.occur_score" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fnSubmitUpdate">提交</el-button>
      </div>
    </el-dialog>
    <!-- <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetPenaltyList" />
    </div> -->
    <el-dialog
      title="积分流水"
      :visible.sync="dialogVisible2"
      width="80%"
    >
      <PointScoreLists :key="`point${scorekey}`" :sub-id="currentChild.sub_id" :sub-name="currentChild.sub_name" />
    </el-dialog>
  </div>

</template>
<script>

// import Select from '@/components/Select'
import PointScoreLists from './PointScoreLists.vue'
// import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'
const defaultSetAdjustPointPostForm = {
  sub_id: '',
  content: '',
  occur_score: '0'
}

export default {
  name: 'TurnStudentList',
  components: {
    // Select
    PointScoreLists
  },
  data() {
    return {
      lists: [],
      setPostForm: Object.assign({}, defaultSetAdjustPointPostForm),
      tableKey: 0,
      dialogVisible1: false,
      dialogVisible2: false,
      currentChild: { sub_id: '', sub_name: '' },
      scorekey: 0,
      total: 0,
      listQuery: {
        p: 1,
        limit: 20,
        sub_name: ''
      },
      rules: {
        content: [{ required: true, trigger: 'manual', message: '请输入说明' }],
        occur_score: [{ validator: (rule, value, callback) => {
          if (value == 0) {
            callback(new Error('请填写积分变动'))
          } else {
            callback()
          }
        }, trigger: 'manual', required: true }]
      }

    }
  },
  created() {
    this.fnGetPointManageList()
  },
  methods: {
    fnGetPointManageList: function() {
      this.$http.getPointManageList(this.listQuery).then(res => {
        this.lists = res.data
        // this.total = parseInt(res.data.count)
      })
    },
    fnFollow(row) {
      this.currentChild.sub_id = row.sub_id
      this.currentChild.sub_name = row.sub_name
      console.log(this.currentChild)
      this.scorekey++
      this.dialogVisible2 = true
    },
    fnUpdate(row) {
      this.setPostForm = Object.assign({}, defaultSetAdjustPointPostForm)
      this.setPostForm.sub_id = row.sub_id
      this.dialogVisible1 = true
    },
    fnSubmitUpdate() {
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.$http.adjustPoint(this.setPostForm).then(res => {
            if (res.code == 200) {
              this.$message({ type: 'success', message: '操作成功!' })
              this.dialogVisible1 = false
              this.fnGetPointManageList()
            }
          })
        }
      })
    }

  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
